/**
 * Отзывы через настоящие ручки из `contract.ts`. Mock (`mocks/store.ts`) —
 * только при `VITE_REVIEWS_MOCK=true`.
 */
import { isApiError } from '../errors'
import type { ApiClient } from '../client'
import type { MyReviewDto, PendingReviewDto, ReviewPageDto } from './contract'
import type { AdminReviewsBackend, MyReviewsBackend } from './mocks/store'

export function createHttpMyReviews(api: ApiClient): MyReviewsBackend {
  return {
    // С API список ожидающих даёт сервер — закрытые заказы приложения не нужны.
    pending: async () =>
      (await api.get<{ items?: PendingReviewDto[] }>('/me/reviews/pending')).items ?? [],
    submit: (orderId, input) => api.post<MyReviewDto>(`/orders/${orderId}/review`, input),
    dismiss: async (orderId) => {
      await api.post<unknown>(`/orders/${orderId}/review/dismiss`)
    },
    forOrder: async (orderId) => {
      try {
        return await api.get<MyReviewDto>(`/orders/${orderId}/review`)
      } catch (error) {
        if (isApiError(error) && error.code === 'not_found') return null
        throw error
      }
    },
  }
}

export function createHttpAdminReviews(api: ApiClient): AdminReviewsBackend {
  return {
    list: (query = {}) =>
      api.get<ReviewPageDto>('/admin/reviews', {
        query: {
          page: query.page,
          page_size: query.pageSize,
          store_id: query.storeId ?? undefined,
          rating: query.rating ?? undefined,
        },
      }),
  }
}
